export const hoverPillClass =
  'flex items-center h-8 px-2 py-1 rounded-full hover:bg-black/5 transition-colors cursor-pointer';
export const countClass = 'text-[15px] text-black/50 tracking-[-0.15px]';
export const actionIconClass = 'size-4 stroke-2 text-black/50';
export const disabledActionClass = 'opacity-40 cursor-not-allowed hover:bg-transparent';
